// Small labelled switch for compact admin cards (the shared Toggle in Elements.jsx
// has large padding). The whole label + track is one button, so either is clickable.
//   size: "sm" (default, 36x20 track) | "xs" (28x16 track)
//   block: true = full-width row, label left / switch right (for settings lists)
//   label: may be empty when the row shows its own label; then pass ariaLabel for screen readers
//   tone: "emerald" (default) | "dark" - track colour when on (dark = gray-900, e.g. Section settings)
//   disabled: shown (dimmed) but cannot be switched
const SIZES = {
  sm: { track: "w-9 h-5", knob: "w-4 h-4", on: "translate-x-4" },
  xs: { track: "w-7 h-4", knob: "w-3 h-3", on: "translate-x-3.5" },
};

export function MiniSwitch({ checked, onChange, label, hint, ariaLabel, size = "sm", block = false, tone = "emerald", disabled = false }) {
  const onColor = tone === "dark" ? "bg-gray-900" : "bg-emerald-500";
  const s = SIZES[size] || SIZES.sm;
  return (
    <button
      type="button"
      role="switch"
      aria-checked={!!checked}
      aria-label={ariaLabel || undefined}
      title={hint}
      disabled={disabled}
      onClick={() => onChange(!checked)}
      className={`${block ? `flex w-full justify-between px-2 py-1.5 ${disabled ? "" : "hover:bg-gray-50"}` : "inline-flex"} items-center gap-2 ${disabled ? "cursor-not-allowed opacity-50" : "cursor-pointer"} select-none rounded-md focus:outline-none focus-visible:ring-2 focus-visible:ring-gray-900 focus-visible:ring-offset-2`}
    >
      {label && <span className={`text-xs font-medium text-gray-700 ${block ? "text-left truncate" : ""}`}>{label}</span>}
      <span
        aria-hidden="true"
        className={`relative inline-flex items-center shrink-0 ${s.track} rounded-full transition-colors ${checked ? onColor : "bg-gray-300"}`}
      >
        <span
          className={`inline-block ${s.knob} rounded-full bg-white shadow transform transition-transform ${checked ? s.on : "translate-x-0.5"}`}
        />
      </span>
    </button>
  );
}

export default MiniSwitch;
